import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('goods_received_notes_1'),
    description: defineMessage('select_status_and_leave_comment'),
    buttonUpdate: defineMessage('update'),
    buttonUpdateTitle: defineMessage('update'),
    fieldStatus: defineMessage('status_1'),
    fieldStatusPlaceholder: defineMessage('select_status_1'),
    fieldComment: defineMessage('comment'),
    fieldCommentPlaceholder: defineMessage('leave_comment'),
    fieldAttachments: defineMessage('attachments'),
    statusNotReceived: defineMessage('not_received'),
    statusPartiallyReceived: defineMessage('partially_received'),
    statusFullyReceived: defineMessage('fully_received'),
    errorFilesCount: defineMessage('sorry_you_cannot_attach_ount_files_to_a_comment'),
    errorFileSize: defineMessage('sorry_the_file_filename_maximum_size_of_maxsize'),
    errorFileType: defineMessage('sorry_the_file_type_of__due_to_security_reasons'),
    grnStatusWasChanged: defineMessage('grn_status_was_changed'),
    goTo: defineMessage('go_to_displayname'),
};
